import {PulseIcon} from '@primer/octicons-react'

const defaultHeading = `No activity matched your search.`
const defaultDescription = `Try expanding your search by selecting a different branch, activity type, user, or timeframe.`

export function ActivityBlankSlate({
  heading = defaultHeading,
  description = defaultDescription,
}: {
  heading?: string
  description?: string
}) {
  return (
    <div className="blankslate">
      <PulseIcon size={24} />
      <h2 className="blankslate-heading">{heading}</h2>
      <p>{description}</p>
    </div>
  )
}
